import { createMigrate } from 'redux-persist';

export const PERSIST_VERSION = 1;

/** Recover the old category cache without resetting the saved NFL selection. */
export const migratePersistedState = createMigrate({
  1: (state) => {
    if (!state) return state;
    const persisted = state as typeof state & { categories?: unknown };
    const categories = persisted.categories as { categories?: unknown; status?: unknown } | undefined;
    const dictionary = categories?.categories;
    const hasDefinitions = dictionary !== null && typeof dictionary === 'object' &&
      !Array.isArray(dictionary) && Object.keys(dictionary).length > 0;

    if (hasDefinitions && categories?.status === 'succeeded') return state;

    // Omitting this slice lets Redux use its initial, fetchable state on rehydration.
    const migrated = { ...persisted };
    delete migrated.categories;
    return migrated;
  },
});
